import { defineStore } from "pinia";
import { ref, watch } from "vue";
import { useEventBus } from "@/Tailwind/Mixins/useEventBus";
import { usePreloadStore } from "@/Tailwind/Stores/preload";

export const KANBAN_VIEW = "kanban";
export const LIST_VIEW = "list";

export const useFilterStore = defineStore(
    "filter",
    () => {
        // State (ref)
        const taskView = ref(KANBAN_VIEW);

        // List filter states here
        const taskFilters = ref({
            statuses: [],
        });

        const documentFilters = ref({});

        const recurringTaskFilters = ref({});

        const assetFilters = ref({});

        // Getters (computed)

        // Mutations (functions)
        const clearFilters = () => {
            taskView.value = KANBAN_VIEW;

            // Clear all filters, make sure to define default state again
            taskFilters.value = {
                statuses: [],
            };

            documentFilters.value = {};

            recurringTaskFilters.value = {};

            assetFilters.value = {
                search: "",
            };
        };

        const setInitialTaskFilters = (filters) => {
            // Set initial task filters
            taskFilters.value = {
                scheduled_for: [],
                ...taskFilters.value,
                ...filters,
            };

            if (filters.view) {
                taskView.value = filters.view;
            }
        };

        const hasFilters = (filterStoreKey) => {
            const filterValues = eval(filterStoreKey)?.value;

            if (!filterValues) {
                return false;
            }

            return Object.values(filterValues).some((value) => {
                if (Array.isArray(value)) {
                    return value.length > 0;
                }

                return value;
            });
        };

        const filterValues = (filterStoreKey) => {
            return eval(filterStoreKey);
        };

        const activeTenants = (spaces) => {
            if (!spaces || !spaces.length) return [];

            const preloadStore = usePreloadStore();
            let hierarchicalSpaces = preloadStore.locations;

            return hierarchicalSpaces.filter(
                (space) =>
                    spaces.includes(space.id) ||
                    space.children.some((child) =>
                        hasRecursiveInChildren(child, "id", spaces)
                    )
            );
        };

        const hasRecursiveInChildren = (object, key, value) => {
            if (
                Array.isArray(value)
                    ? value.includes(object[key])
                    : object[key] === value
            ) {
                return true;
            }

            const found = object.children.some((child) => {
                return hasRecursiveInChildren(child, key, value);
            });

            return found;
        };

        // Listen to clear filter bus event
        const { bus } = useEventBus();

        watch(
            () => bus.value.get("clearFilters"),
            () => {
                clearFilters();
            }
        );

        return {
            // State
            taskView,
            taskFilters,
            documentFilters,
            recurringTaskFilters,
            assetFilters,
            // Getters
            // Mutations
            setInitialTaskFilters,
            filterValues,
            clearFilters,
            activeTenants,
            hasFilters,
        };
    },
    {
        persist: true,
    }
);
